module.exports = __webpack_public_path__ + "img/03-THREE PATTERNS.svg";